import s from '../../styles/components/redeem/RedeemInvalid.module.css';

export default function RedeemInvalid({ ui }) {
  return (
    <div className={s.wrap}>
      <h2 className={s.headline}>{ui.headline}</h2>
      <p className={s.subhead}>{ui.subhead}</p>
      {ui.cta && (
        <a href={ui.cta.url} className={s.cta}>{ui.cta.label}</a>
      )}
    </div>
  );
}